exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.back[data-v-7b347d63] {\n  display: flex;\n  align-items: center;\n  background: white;\n\n  margin-bottom: 5px;\n  padding: 10px 25px;\n\n  font-size: 14px;\n  line-height: 16px;\n  height: 25px;\n  color: #4f4f4f;\n  text-decoration: none;\n}\n.back[data-v-7b347d63]:hover {\n  text-decoration: underline;\n}\n.back .icon[data-v-7b347d63] {\n  transform: rotate(180deg);\n  font-size: 18px;\n  color: red;\n}\n", ""]);

// exports
